import { createReducer, on } from '@ngrx/store';
import { WidgetsActions, RouterActions } from '@actions/index'
import { ReviewModel, ReviewPageRequestDescriptor } from '@models/index'

/**
 * Widget's app State. Defines the
 * app State that will store widget's
 * information.
 */
export interface State {
    /**
     * reviews: An array of {@link  ReviewModel} 
     * that contains the location's reviews that 
     * match widget's
     * settings
     */
    reviews: ReviewModel [];
    /**
     * total: Stores the ammount of location's
     * reviews that match widget's settings
     */
    total: number;
    /**
     * reviewsCount: Stores the ammount of
     * all location's reviews
     */
    reviewsCount: number;
    /**
     * rating: Contains the location's
     * overall rating
     */
    rating: number;
    /**
     * starsCount: Stores the location's
     * review stars distribution
     */
    starsCount: number[];
    /**
     * landing: Contains the location's
     * generic landing URL
     */
    landing: string;
    /**
     * url: Contains the url associated
     * with the specific location's widget
     */
    url: string;
    /**
     * error: Stores the error returned
     * on a widget petition if existed
     */
    error: string;
    pagesId: ReviewPageRequestDescriptor[];
}

const initialState: State = {
    reviews: [],
    total: 0,
    reviewsCount: 0,
    rating: 0,
    starsCount: [],
    landing: '',
    url: '',
    error: '',
    pagesId: [],
};

/**
 * reducer creates the widget's reducer.
 * This reducer listens to all succesfull
 * widgets actions to store the returned 
 * data to widget's app state depending
 * on the action
 */
export const reducer = createReducer(
    initialState,
    on(WidgetsActions.searchWidgetReviewsSuccess, (state, { data, total }) => ({
        ...state,
        reviews: data,
        total,
    })),
    on(WidgetsActions.getWidgetUrlSuccess, (state, { widgetUrl }) => ({ ...state, url: widgetUrl })),
    on(WidgetsActions.getLoctionReviewsCountSuccess, (state, { reviewsCount }) => ({ ...state, reviewsCount })),
    on(WidgetsActions.getLoctionOverallRatingSuccess, (state, { rating }) => ({ ...state, rating })),
    on(WidgetsActions.getLoctionStarsCountSuccess, (state, { starsCount }) => ({ ...state, starsCount })),
    on(WidgetsActions.getLoctionGenericLandingSuccess, (state, { landing }) => ({ ...state, landing })),
    on(WidgetsActions.widgetError, (state, { error }) => ({ ...state, error: error })),
    on(RouterActions.navigateAuth, () => ({ ...initialState })),
    on(WidgetsActions.getPagesIdWidgetsSuccess, (state, { data }) => ({
        ...state,
        pagesId: data
    })),
);

/**
 * Returns the reviews property
 * from widget's app state
 * @param state 
 */
export const getReviews = (state: State) => state.reviews;
/**
 * Returns the total property
 * from widget's app state
 * @param state 
 */
export const getTotal = (state: State) => state.total;
/**
 * Returns the url property
 * from widget's app state
 * @param state 
 */
export const getUrl = (state: State) => state.url;
/**
 * Returns the reviewsCount property
 * from widget's app state
 * @param state 
 */
export const getReviewsCount = (state: State) => state.reviewsCount;
/**
 * Returns the rating property 
 * from widget's app state
 * @param state 
 */
export const getRating = (state: State) => state.rating;
/**
 * Returns the starsCount property
 * from widget's app state
 * @param state 
 */
export const getStarsCount = (state: State) => state.starsCount;
/**
 * Returns the landing property
 * from widget's app state
 * @param state 
 */
export const getLanding = (state: State) => state.landing;
/**
 * Returns the error property
 * from widget's state
 * @param state 
 */
export const getError = (state: State) => state.error;
export const getPagesId = (state: State) => state.pagesId;

